import { useCallback, useState } from "react";

/**
 * Tracks which tabs have already been shown so one-off entrance motion is not
 * replayed when a tab is revisited. Lives at page level because tab panels
 * unmount when hidden.
 */
export const useVisitedTabs = <TKey extends string>() => {
  const [visitedTabKeys, setVisitedTabKeys] = useState(() => new Set<TKey>());

  const markVisited = useCallback((key: TKey) => {
    setVisitedTabKeys((current) => {
      if (current.has(key)) return current;
      return new Set(current).add(key);
    });
  }, []);

  const hasVisited = (key: TKey) => visitedTabKeys.has(key);

  return { hasVisited, markVisited };
};
